module.exports = __webpack_public_path__ + "img/sun-wood-tower.c3725385.png";